<script>
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import Card from "../Card.svelte";
  import CardBody from "../CardBody.svelte";

  export let url = "";
  export let title;
  export let description = "";

  export let imageComponent;
  export let resizeParams;
  export let widthsAt = {};
</script>

<Card
  {url}
  class="group w-full rounded-5 border border-transparent focus:border-black focus:shadow-card focus-within:border-black focus-within:shadow-card active:shadow-card"
>
  <div class="flex flex-row items-center rounded-5 bg-white">
    <CardBody
      {title}
      {description}
      {url}
      bodyClass="flex flex-col p-16 md:p-24 gap-16 items-start group-hover:underline order-2"
      titleClass="heading-card font-normal leading-6.5 focus:!bg-none focus:outline-none group-focus:!no-underline active:text-black"
      horizontal
    />

    <!-- image -->
    {#if imageComponent}
      <ImageComponent
        containerClass="w-136 md:w-191 overflow-hidden rounded-l-5"
        elementClass="w-full object-cover aspect-square"
        data={imageComponent}
        displayCaption={false}
        responsive
        {resizeParams}
        {...widthsAt}
      />
    {/if}
  </div>
</Card>
